import React from 'react';
import './PokersiteFilter.css';

import { PokersiteOptions } from './constants';

import Suggestions, { Suggestion } from '../Suggestions/Suggestions';
import Flex from '../Flex/Flex';
import Text from '../Text/Text';
import CaretDownIcon from '../../assets/Icons/CaretDownIcon.svg?react';
import useOutsideClick from '../../hooks/useOutsideClick';

type Props = {
  value: number;
  onChange: (value: number) => void;
};

const PokersiteFilter = React.memo(({ onChange, value }: Props) => {
  const filterRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;

  const [needToShowSuggests, setNeedToShowSuggests] = React.useState(false);

  const handleOutsideClick = React.useCallback(() => {
    setNeedToShowSuggests(false);
  }, []);

  useOutsideClick(filterRef, handleOutsideClick);

  const handlePickerClick = React.useCallback(() => {
    setNeedToShowSuggests((x) => !x);
  }, []);

  const handleSelectLimit = React.useCallback(
    (suggestion: Suggestion) => {
      onChange(suggestion.id);
      setNeedToShowSuggests(false);
    },
    [onChange],
  );

  return (
    <div className="PokersiteFilter" ref={filterRef}>
      <Flex align="center" className="Filter__labelContent">
        <Text size={2} type="secondary">
          Room
        </Text>
      </Flex>
      <Flex
        className="PokersiteFilter__limit-picker"
        justify="space-between"
        align="center"
        onClick={handlePickerClick}
      >
        <Text size={1} bold>
          {PokersiteOptions.find((x) => x.id === value)?.label}
        </Text>
        <i className="PokersiteFilter__picker-icon">
          <CaretDownIcon />
        </i>
      </Flex>
      {needToShowSuggests && (
        <Suggestions suggestions={PokersiteOptions} onClick={handleSelectLimit} />
      )}
    </div>
  );
});

export default PokersiteFilter;
